 
import {Answer} from './Answer';

export class SignInOutRequest {
    
    public buildingId: string;
    public answers: Array<Answer>;
    public questionInfo: string;
    public latitude: number;
    public longitude: number;
    constructor(init?:Partial<SignInOutRequest>) {
        
        Object.assign(this, init);
    }
}



// WEBPACK FOOTER //
// ./models/SignInOutRequest.ts